import { globalTheme } from "./Theme";
import styled, { css, createGlobalStyle, keyframes } from "styled-components";
import { GetValueWithUnit, } from "../../MakersV2/globalFunctions";
import { forwardRef, useEffect, useRef, useState } from "react";
import { Heading4, Text } from "./Typography";
import { ArrowDown, Close, CloseCircle, CoworkLogo, EyeClose, EyeOpen, MakerslabIcon, Search, UploadFile } from "./Icons";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import Multiselect from "multiselect-react-dropdown";


export const customProps = new Set([
  'background', 'wrap', 'noWrap',
  'active', 'commonButton', 'alignCenter',
  'justiCenter', 'column', 'Width',
  'row', 'colRev', 'rowRev', 'boxShadow',
  'spaceBW', 'flexStart', 'roundButton',
  'flexEnd', 'flexGrow', 'overFlow',
  'height', 'minHeight', 'maxHeight',
  'alignStart', 'baseline', 'alignEnd',
  'alignLeft', 'contentstart', 'contentCenter',
  'textcenter', 'stretch', 'gap',
  'width', 'rowGap', 'maxWidth', 'medium',
  'margin', 'padding', 'buttonLg',
  'minWidth', 'bgColor', 'thickness',
  'blankSpace', 'defaultCursor', 'fontSize',
  'marginBottom', 'marginTop', 'darkTheme',
  'paddingleft', 'no', 'size', 'newStyle',
  'borderColor', 'fullheight', 'transparent',
  'orange', 'orangeOutlined', 'buttonXs',
  'cursor', 'revIcon', 'Flexstart',
  'Black1', 'FlexStart', 'fullCanvas',
  'sideMenu', 'sideMenuColor', 'primaryOutlined',
  'buttonSm', 'greenFilled', 'greyFilled',
  'orangeFilled', 'secondary', 'buttonMd',
  'primaryFilled', 'greyOutlined', 'yellow',
  'Height', 'borderRadius', 'toggleSize',
  'full', 'blue', 'green', 'isCalling',
  'red', 'error', 'small', 'gradientOutlined',
  'primaryGrey', 'flexCenter', 'isViewOnly',
  'fontSize13', 'theme', 'color',
  'underline', 'circle', 'className',
  'overflow', 'noPointer', 'noHoverUnderline',
  'MobMenu', 'fullBtn', 'orangeOutlinedWhite',
]);


export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Inter", sans-serif;
    -webkit-tap-highlight-color: transparent;
  }

  p {
    margin-bottom: 0;
  }

  
     @keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }


  .Ellipses{
     display: -webkit-box;        
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;       
  overflow: hidden;            
  text-overflow: ellipsis;    
  max-width: 360px; 
  }

  .hide {
    display: none;
  }

  .pointer {
    cursor: pointer !important;
  }

  .disabled {
    cursor: not-allowed !important;
  }

  .wait {
    cursor: wait !important;
  }

  .relative {
    position: relative;
  }

  .inColpse {
    max-width: calc(25% - 15px) !important;
  }

  .inColpse2 {
    max-width: calc(49% - 10px) !important;
  }

  .inColpse3 {
    width: calc(32% - 10px) !important;
  }

  .inColpse4 {
    width: calc(24% - 10px) !important;
  }

  .Imp{
    color: ${globalTheme.colors.red} !important;
  }

  
.JointSearchbox{
        .joinInput{
            input{
            height: 44px !important;
            border-radius: 0 6px 6px 0;
          }
        }
  
      .css-13cymwt-control{
        border-radius: 6px 0 0 6px !important;
        border-right: none;
      }
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  @keyframes fadeIn {
    0% { opacity: 0 }
    to { opacity: 1 }
  }

  ${[...Array(201).keys()].map(i => `
  .mt-${i} {
    margin-top: -${i}px !important;
  }
  `,
).join("\n")}
  
  ${[...Array(201).keys()].map(i => `
  .mt${i} {
    margin-top: ${i}px !important;
  }
  `,
).join("\n")}

${[...Array(201).keys()].map(i => `
  .mb-${i} {
    margin-bottom: -${i}px !important;
  }
  `,
).join("\n")}

  ${[...Array(201).keys()].map(i => `
  .mb${i} {
    margin-bottom: ${i}px !important;
  }
  `,
).join("\n")}

  ${[...Array(201).keys()].map(i => `
  .ml${i} {
    margin-left: ${i}px !important;
  }
  `,
).join("\n")}

  ${[...Array(201).keys()].map(i => `
  .mr${i} {
    margin-right: ${i}px !important;
  }
  `,
).join("\n")}

  ${[...Array(201).keys()].map(i => `
  .pl${i} {
    padding-left: ${i}px;
  }
  `,
).join("\n")}

  ${[...Array(201).keys()].map(i => `
  .pr${i} {
    padding-right: ${i}px;
  }
  `,
).join("\n")}

  .gap-5 {
    gap: 5px !important;
  }

  .mxAuto {
    margin: 0 auto;
  }

  .disBlock {
    display: block;
  }
  
  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0; 
  }

  ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${globalTheme?.colors?.nuetral3};
    border-radius: 15px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  .tableWrapper {
    border-radius: 10px;
    background: ${globalTheme?.colors?.white1};
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.04);
    overflow: auto;
    max-height: calc(100vh - 200px);
    
    &.autoHeight{
      max-height:calc(100% - 250px);
    }
  

    td:nth-child(3) .tabBox {
      max-width: 300px;
      min-width: 200px;
      white-space: nowrap;

      .tabBoxContent{
       max-width: 270px;
      min-width: 200px;
      }
    
    }
    


    .tabBox.thirdChild {
        min-width: max-content !important;
      }

    /* A short table has no rows below the last one for its action menu /
       tooltip to open into, and this wrapper scroll-clips anything that
       overflows it — which is why a 2-row table showed a menu sliced off at
       the bottom edge. Reserve scroll room under the last row so the menu has
       somewhere to land. Only for tables of 4 rows or fewer; longer tables
       flip their menus upward instead and need no extra space. */
    &:has(tbody tr:nth-child(-n + 4):last-child) .mainTable {
      padding-bottom: 130px;
    }

    table {
      position: relative;
      width: 100%;
      z-index: 1;
      border-collapse: collapse;
    }
    
    .tabBox {
      padding: 16px 16px;
      color: ${globalTheme.colors.nuetral13};
      font-family: ${globalTheme.fonts.inter};
      font-size: 13px;
      font-style: normal;
      font-weight: ${globalTheme.fontWeights.medium};
      line-height: 20px;
      text-align: left;
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: max-content;


      .tabBoxContent {
        overflow: hidden;
        /* display: flex; */
        align-items:center;
        gap:2px;
        max-width:150px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    
    }
    

    thead {
      border-bottom: 1px solid ${globalTheme.colors.nuetral13};
      background: ${globalTheme.colors.grey8};
      position: sticky;
      top: 0;
      z-index: 99;

      .tabBox {
        color: ${globalTheme.colors.black2} !important;
        transition: 0.4s ease;
      }
    }

    tbody {
      tr {
        border-top: 1px solid rgba(0, 0, 0, 0.03);
        transition: 0.4s ease;
        background: ${globalTheme.colors.white1};
        cursor: default;


        &:hover {
          background: ${globalTheme.colors.white} !important;
          transition: 0.4s ease;
          
          td:nth-child(1), td:nth-child(2),td:nth-child(3),td:last-child{
            background: ${globalTheme.colors.white} !important;
            transition: 0.4s ease;
          }
          
          .tabBox {
            color: ${globalTheme.colors.black2} !important;
            transition: 0.4s ease;
          }
        }

        /* Row action menus open DOWN by default. */
        ul {
          top: 100%;
          bottom: auto;
        }

        /* ...and flip UP only for rows near the bottom that also have enough
           rows above them to open into. The two rules used to be written as
           "first 5 rows open down" + "last 5 rows open up", which on a short
           table (2-3 rows) matched the SAME row: it got top:100% !important AND
           bottom:100% at once, so the menu was stretched between both edges and
           landed on top of the row and the tooltip. The :not() keeps the two
           sets disjoint at every row count. */
        &:nth-last-child(-n + 5):not(:nth-child(-n + 4)) {
          ul {
            top: auto;
            bottom: 100%;
          }
        }

        &.active {
          background: ${globalTheme.colors.white2};
          transition: 0.4s ease;
        }
      }

      .szh-accordion__item-content {
        margin-top: 0;
      }

      #view {
        cursor: pointer !important;
      }
    }
  }



  @keyframes l1 {to{clip-path: inset(0 -20% 0 0)}}

  /* =====================================================================
     RESPONSIVE LAYER

     HARD RULE: every declaration below lives inside a media query, and the
     widest query is max-width: 1200px. Above 1200px this block contributes
     ZERO CSS, so the desktop layout renders exactly as it did before.

     Layout in this app is expressed as props on <Flexbox>/<WrapperBox>
     (flex-wrap, max-width, gap). Those props apply at every width, so they
     must NOT be edited to make small screens work — doing that changes
     desktop too. Instead the JSX only carries marker classNames, and the
     behaviour is switched on here, per breakpoint.

     Overrides are !important because createGlobalStyle and component styles
     have no guaranteed injection order in styled-components v6.

     Breakpoints: 1200 small laptop / 992 tablet + drawer / 900 toolbars
                  / 768 single column / 560 phone / 380 small phone
     ===================================================================== */

  /* The single exception to the rule above: the mobile bar is a brand-new
     element that must be hidden by default, so hiding it cannot regress
     anything that previously rendered. It is revealed at 992 below. */
  .mobileTopBar {
    display: none !important;
  }

  /* ---- 1200: room/booking card grids go 3-up -> 2-up ------------------ */
  @media (max-width: 1200px) {
    .respCard3 {
      max-width: 48% !important;
      flex-basis: 48%;
      min-width: 0;
    }
  }

  /* ---- 1100: dashboard side-by-side panels stack ---------------------- */
  @media (max-width: 1100px) {
    .respPanelRow {
      flex-wrap: wrap !important;
      row-gap: 12px !important;
    }

    .respHalf {
      max-width: 100% !important;
      flex-basis: 100%;
      min-width: 0;
    }
  }

  /* ---- 992: sidebar becomes an off-canvas drawer ---------------------- */
  @media (max-width: 992px) {
    .respStatRow {
      flex-wrap: wrap !important;
      row-gap: 12px !important;
    }

    .respStat4 {
      max-width: calc(50% - 6px) !important;
      flex-basis: calc(50% - 6px);
      min-width: 0;
    }

    .mainSideMenuWrap.mainSideMenuWrap {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      bottom: 0 !important;
      width: 260px !important;
      min-width: 260px !important;
      padding: 24px 18px !important;
      overflow-y: auto !important;
      overflow-x: hidden !important;
      transform: translateX(-100%);
      transition: transform 0.28s ease !important;
      z-index: 1001;
    }

    .mainSideMenuWrap.isOpen {
      transform: translateX(0);
      box-shadow: 0 0 40px rgba(0, 0, 0, 0.35);
    }

    /* Collapsing to icons is meaningless once the panel is a drawer. */
    .sidebarCollapseBtn {
      display: none !important;
    }

    .overlay {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.45);
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.25s ease, visibility 0.25s ease;
      z-index: 1000;
    }

    .mobileTopBar {
      display: flex !important;
    }

    /* The mobile bar sits above the outlet, so the outlet can no longer
       claim the full height without producing a phantom scrollbar. */
    .appMainScroll {
      height: auto !important;
      min-height: calc(100% - 60px);
    }

    /* Lets the content column shrink instead of forcing a page-wide
       horizontal scrollbar. */
    .appContentArea {
      min-width: 0;
    }
  }

  /* ---- 992: login art + form stack ------------------------------------- */
  @media (max-width: 992px) {
    .loginRow {
      flex-direction: column !important;
      align-items: center !important;
      row-gap: 24px !important;
    }

    .loginArt {
      max-width: 70% !important;
    }

    .loginCard.loginCard {
      max-width: 520px !important;
    }
  }

  /* ---- 900: header toolbars stack -------------------------------------- */
  /* NOTE ON THE DOUBLED CLASS NAMES BELOW (.x.x):
     WrapperBox and Flexbox emit padding and border-radius with !important
     (see StyledWrapper / Flexbox). A single class here has the SAME
     specificity (0,1,0) as the generated .sc-* class, so with !important on
     both sides the winner comes down to stylesheet injection order — which
     createGlobalStyle does not guarantee against component styles. Repeating
     the class lifts this to (0,2,0) so it wins deterministically. Only needed
     for padding / border-radius / margin / row-gap. */
  @media (max-width: 900px) {
    .respToolbar.respToolbar {
      flex-direction: column !important;
      flex-wrap: wrap !important;
      align-items: stretch !important;
      row-gap: 14px !important;
    }

    .respToolbar.respToolbar > * {
      max-width: 100% !important;
      width: 100% !important;
    }

    .respToolbarGroup.respToolbarGroup {
      flex-wrap: wrap !important;
      gap: 10px !important;
      row-gap: 10px !important;
      justify-content: flex-start !important;
    }

    /* Filter pills sit on one wrapped row — let them share the width evenly
       instead of hugging their labels, and stop the last one on a row from
       being pushed past the shell's rounded corner. */
    .respToolbarGroup.respToolbarGroup > * {
      flex: 1 1 auto;
      min-width: 0;
    }

    /* An 80px radius is a pill on one row, but on a three-row stack the corner
       curve sweeps so far in that content near the bottom corners reads as
       falling outside the box. Square it off and pad it properly. */
    .respToolbarShell.respToolbarShell {
      border-radius: 24px !important;
      padding: 14px !important;
    }

    /* Heights budgeted for a one-row desktop header are wrong once that
       header wraps — scroll the page instead of clipping the content. */
    .respNoMaxH.respNoMaxH {
      max-height: none !important;
    }
  }

  /* ---- 768: single column ---------------------------------------------- */
  @media (max-width: 768px) {
    .respCard3 {
      max-width: 100% !important;
      flex-basis: 100%;
    }

    /* Dense meta rows (location/badge, seats/amenities, date/time/people)
       wrap instead of overflowing the now-narrow card. */
    .respMetaRow {
      flex-wrap: wrap !important;
      row-gap: 8px !important;
    }

    /* Form rows put 2-3 inputs side by side with no wrap, so on a phone each
       field got ~80px — the Tower pill's label wrapped to three lines inside
       its own chip. Give every field the full width instead. */
    .respFormRow.respFormRow {
      flex-direction: column !important;
      align-items: stretch !important;
      row-gap: 16px !important;
    }

    .respFormRow.respFormRow > * {
      max-width: 100% !important;
      width: 100% !important;
    }

    .respTruncate {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .respPagePad.respPagePad {
      padding: 12px !important;
    }

    /* A 50px radius reads as a pill once the card is only ~340px wide. */
    .respCardPad.respCardPad {
      padding: 12px 12px 16px !important;
      border-radius: 28px !important;
    }

    /* The sign-in art is decorative and eats the whole fold on a phone —
       drop it so the form is what you land on. */
    .loginArt {
      display: none !important;
    }

    .loginCard.loginCard {
      max-width: 100% !important;
      padding: 24px !important;
      border-radius: 24px !important;
    }
  }

  /* ---- 560: phone ------------------------------------------------------- */
  @media (max-width: 560px) {
    .respStat4 {
      max-width: 100% !important;
      flex-basis: 100%;
    }

    /* Paired full-width buttons (Edit / View Bookings, tab switchers) are
       set to width:100%, so they can only be stacked by switching the axis —
       adding flex-wrap would wrap them at EVERY width, desktop included. */
    .respBtnRow.respBtnRow,
    .respTabRow.respTabRow {
      flex-direction: column !important;
      align-items: stretch !important;
      row-gap: 8px !important;
    }

    /* A max-content shell around a stacked switcher leaves the pill hugging
       the wider label, so the two buttons come out ragged. Let the shell and
       the row take the full width so both options are the same size. */
    .respTabShell.respTabShell,
    .respTabRow.respTabRow {
      max-width: 100% !important;
    }

    /* The switcher shell is a pill built for a single 36px-tall row; once the
       options stack it needs real padding and a squared-off radius. */
    .respTabShell.respTabShell {
      border-radius: 22px !important;
      padding: 8px !important;
    }

    /* buttonMd is a cramped 8px/36px — too tight for a stacked full-width
       option, and below the 44px minimum comfortable touch target. */
    .respTabRow.respTabRow > * {
      height: auto !important;
      min-height: 44px !important;
      padding: 12px 18px !important;
    }

    .respPagePad.respPagePad {
      padding: 10px !important;
    }
  }

  /* ---- 480: narrow phone ------------------------------------------------ */
  @media (max-width: 480px) {
    /* Date button + participants picker: the picker has a 195px floor, which
       leaves too little for the date once the card is this narrow. */
    .respFieldRow {
      flex-direction: column !important;
      align-items: stretch !important;
      row-gap: 12px !important;
    }

    .respFieldRow > * {
      max-width: 100% !important;
      width: 100% !important;
    }
  }

  /* ---- 380: smallest supported (iPhone SE / older Android) -------------- */
  @media (max-width: 380px) {
    .respPagePad.respPagePad {
      padding: 8px !important;
    }

    .loginCard.loginCard {
      padding: 18px !important;
      border-radius: 20px !important;
    }

    .respCardPad.respCardPad {
      padding: 10px 10px 14px !important;
      border-radius: 22px !important;
    }
  }
`;


export const WrapperBox = ({ children, borderColor, gradient, boxShadow, background, padding, borderRadius, maxWidth,minWidth, Width, className, onClick, Height, maxHeight, overflow, margin }) => (
  <StyledWrapper
    maxWidth={maxWidth}
    minWidth={minWidth}
    Width={Width}
    margin={margin}
    Height={Height}
    overflow={overflow}
    maxHeight={maxHeight}
    borderRadius={borderRadius}
    padding={padding}
    background={background}
    boxShadow={boxShadow}
    gradient={gradient}
    borderColor={borderColor}
    className={className}
    onClick={onClick}
  >
    {children}
  </StyledWrapper>
);

const StyledWrapper = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
position: relative;
  border: 1px solid transparent;
  line-height: 0;
  width: ${props => props.Width ? GetValueWithUnit(props.Width) : "100%"}; 
  ${props => props.maxWidth ? `max-width: ${GetValueWithUnit(props.maxWidth)};` : ""}
  ${props => props.minWidth ? `min-width: ${GetValueWithUnit(props.minWidth)};` : ""}
  ${props => props.Height ? `height: ${GetValueWithUnit(props.Height)};` : ""}
  ${props => props.maxHeight ? `max-height: ${GetValueWithUnit(props.maxHeight)};` : ""}
  ${props => props.margin ? `margin: ${GetValueWithUnit(props.margin)};` : ""}
  ${({ borderColor }) => borderColor && css`${borderColor && `border-color: ${borderColor};`}`}
  ${({ gradient }) => gradient && css`background: linear-gradient(#fff 0 0) padding-box, linear-gradient(90.18deg, #39B6D8 6.41%, #F7D344 51.47%, #E38330 96.52%) border-box !important;`}
  ${props => props.boxShadow && css`box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);`}
  ${({ overflow }) => css`overflow: ${overflow ? overflow : 'auto'};`}
  ${({ background }) => css`background: ${background ? background : globalTheme.colors.white1};`}
  ${props => props.padding ? `padding: ${props.padding} !important;` : `padding:20px;`}
  ${props => props.borderRadius && `border-radius: ${props.borderRadius}px !important;`}
`;

export const Button = forwardRef(({
  className,
  active,
  icon,
  name,
  revIcon,
  minWidth,
  maxWidth,
  disabled,
  onClick,
  buttonXs,
  buttonSm,
  buttonMd,
  buttonLg,
  buttonXl,
  primaryFilled,
  primaryOutlined,
  orangeFilled,
  orangeOutlined,
  orangeOutlinedWhite,
  greyOutlined,
  greyFilled,
  gradientOutlined,
  greenFilled,
  greenOutlined,
  redFilled,
  whiteFilled,
  whiteOutlined,
  fullBtn,
  marginBottom,
  marginTop,
  gap,
  lineHeight,
  borderRadius,
  height,
  color,
  roundButton,
  blackFilled,
  cursor = "pointer",
  type = "button",
  style,
  bgColor,
  customPadding,
}, ref) => {
  return (
    <StyledButton
      blackFilled={blackFilled}
      type={type}
      cursor={cursor}
      className={className}
      disabled={disabled}
      onClick={onClick}
      revIcon={revIcon}
      buttonXs={buttonXs}
      buttonSm={buttonSm}
      buttonMd={buttonMd}
      buttonLg={buttonLg}
      buttonXl={buttonXl}
      primaryFilled={primaryFilled}
      primaryOutlined={primaryOutlined}
      orangeFilled={orangeFilled}
      orangeOutlined={orangeOutlined}
      orangeOutlinedWhite={orangeOutlinedWhite}
      greyOutlined={greyOutlined}
      gradientOutlined={gradientOutlined}
      greyFilled={greyFilled}
      greenFilled={greenFilled}
      whiteFilled={whiteFilled}
      whiteOutlined={whiteOutlined}
      redFilled={redFilled}
      greenOutlined={greenOutlined}
      fullBtn={fullBtn}
      minWidth={minWidth}
      maxWidth={maxWidth}
      marginBottom={marginBottom}
      marginTop={marginTop}
      gap={gap}
      borderRadius={borderRadius}
      lineHeight={lineHeight}
      height={height}
      roundButton={roundButton}
      style={style}
      bgColor={bgColor}
      ref={ref}
      color={color}
      customPadding={customPadding}
    >
      {name} {icon}
    </StyledButton>
  );
});

const StyledButton = styled.button.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  ${props => css`
    outline: none;
    line-height: 130%;
    box-shadow: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: ${props.cursor || "pointer"} !important;
    border-radius: 80px;
    background-color: ${(props) => props.bgColor ? props.bgColor : 'transparent'};
    font-family: ${globalTheme.fonts.inter};
    border: 1px solid transparent;

    ${props.commonButton && "/* Add common button styles here */"}
    ${props.disabled && "cursor: not-allowed; opacity: 0.5;"}
    ${props.revIcon && "flex-direction: row-reverse;"}

    ${props.buttonXs && "padding: 8px 12px; font-size: 14px;"}
    ${props.buttonSm && "padding: 5px 16px; font-size: 14px; height: 30px;"}
    ${props.buttonMd && "padding: 8px 12px; font-size: 14px; height: 36px;"}

    ${props.buttonLg && "padding: 5px 12px; font-size: 14px; height: 50px;"}
    ${props.buttonXl && "padding: 12px 32px; font-size: 14px;"}
     ${props.gradientOutlined && `background: linear-gradient(#fff 0 0) padding-box,
        linear-gradient(90.18deg, #39B6D8 6.41%, #F7D344 51.47%, #E38330 96.52%) border-box ; border-color: transparent; color: ${globalTheme.colors.black4};`}
    
    ${props.primaryFilled && `background: ${globalTheme.colors.black4}; color: ${globalTheme.colors.white1};`}
    ${props.primaryOutlined && `border-color: ${globalTheme.colors.grey4}; color: ${globalTheme.colors.black3}; background: ${globalTheme.colors.white1};transition:0.4s; &:hover {border-color: ${globalTheme.colors.nuetral13};transition:0.4s; }`}

    ${props.orangeFilled && `background-color: ${globalTheme.colors.primary}; color: ${globalTheme.colors.white1} ; transition:0.4s; &:hover {background-color: ${globalTheme.colors.primaryDark};transition:0.4s; }`}
    ${props.orangeOutlined && `border-color: ${globalTheme.colors.nuetral2}; color: ${globalTheme.colors.primary}; background: ${globalTheme.colors.primary1};`}
    ${props.orangeOutlinedWhite && `background-color: ${globalTheme.colors.white1}; border-color: ${globalTheme.colors.primary}; color: ${globalTheme.colors.primary};`}

    ${props.greyOutlined && `border-color: ${globalTheme.colors.grey6}; color: ${globalTheme.colors.nuetral6};`}
    ${props.greyFilled && `border-color: ${globalTheme.colors.grey6}; background-color: ${globalTheme.colors.nuetral2}; color: ${globalTheme.colors.black3};`}
    
    ${props.greenFilled && `background-color: ${globalTheme.colors.success4}; color: ${globalTheme.colors.white1};`}
    ${props.greenOutlined && `border-color: ${globalTheme.colors.success4}; color: ${globalTheme.colors.success4};`}

    ${props.redFilled && `background-color: ${globalTheme.colors.error}; color: ${globalTheme.colors.white1};`}
    ${props.blackFilled && `background-color: ${globalTheme.colors.black4}; color: ${globalTheme.colors.white1};`}

    ${props.whiteFilled && `background-color: ${globalTheme.colors.white1}; color: ${globalTheme.colors.nuetral10};`}
    ${props.whiteOutlined && `border-color: ${globalTheme.colors.white1}; color: ${globalTheme.colors.white1};`}

    ${props.fontSize && `font-size: ${props.fontSize}px;`}
    ${props.lineHeight && `line-height: ${props.lineHeight}%;`}

    ${props.fullBtn && "width: 100%;"}
    ${props.minWidth && `min-width: ${props.minWidth}px;`}
    ${props.maxWidth && `max-width: ${props.maxWidth}px;`}

    ${props.roundButton && `border-radius: 30px;`}
    ${props.customPadding && `padding: ${props.customPadding} !important;`}

    ${props.height && `height: ${props.height}px;`}

    ${props.gap ? `gap: ${props.gap}px;` : `gap: 10px`}
    ${props.marginBottom && `margin-bottom: ${props.marginBottom}px;`}
    ${props.marginTop && `margin-top: ${props.marginTop}px;`}
    
    ${props.color && `color: ${props.color} !important;`}

    > svg{
      width: 14px;
      height: 14px;
    }
  `}
`;

export const Flexbox = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  width: ${props => props.width ? props.width : "100%"};
  display: flex;
  position: ${props => props.position ? props.position : "relative"};
  ${props => (props.background ? `background: ${props.background} !important;` : "")} 
  ${props => (props.wrap ? "flex-wrap: wrap;" : "")}
  ${props => (props.noWrap ? "flex-wrap: nowrap;" : "")}
  ${props => (props.alignCenter ? "align-items: center;" : "")}
  ${props => (props.justiCenter ? "justify-content: center;" : "")}
  ${props => (props.column ? "flex-direction: column;" : "")}
  ${props => (props.row ? "flex-direction: row;" : "")}
  ${props => (props.colRev ? "flex-direction: column-reverse;" : "")}
  ${props => (props.rowRev ? "flex-direction: row-reverse;" : "")}
  ${props => (props.spaceBW ? "justify-content: space-between;" : "")}
  ${props => (props.flexStart ? "justify-content: flex-start;" : "")}
  ${props => (props.flexEnd ? "justify-content: flex-end;" : "")}
  ${props => props.flexGrow ? `flex-grow: ${props.flexGrow};` : `flex-grow: 0;`}
  ${props => props.overFlow ? `overflow: ${props.overFlow};` : `overflow: visible;`}
  ${props => (props.height ? `height: ${props.height};` : `height: auto;`)}
  ${props => (props.minHeight ? `min-height: ${props.minHeight};` : `min-height: auto;`)}
  ${props => (props.maxHeight ? `max-height: ${props.maxHeight};` : `max-height: auto;`)}
  ${props => (props.alignStart ? "align-items: flex-start;" : "")}
  ${props => (props.baseline ? "align-items: baseline;" : "")}
  ${props => (props.alignEnd ? "align-items: flex-end;" : "")}
  ${props => (props.contentstart ? "justify-content: flex-start;" : "")}
  ${props => (props.contentCenter ? "justify-content: center;" : "")}
  ${props => (props.textcenter ? "text-align: center;" : "")}
  ${props => (props.stretch ? "align-items: stretch;" : "")}
  ${props => (props.gap ? `gap: ${props.gap}px;` : "")}
  ${props => (props.width ? `width: ${props.width}%;` : "")}
  ${props => (props.rowGap ? `row-gap: ${props.rowGap}px !important;` : "")}
  ${props => props.maxWidth ? `max-width: ${GetValueWithUnit(props.maxWidth)};` : ""}
  ${props => props.margin ? `margin: ${props.margin} !important;` : "0px;"}
  ${props => props.padding ? `padding: ${props.padding} !important;` : "0px;"}
  ${props => props.borderRadius && `border-radius: ${props.borderRadius}px !important;`}

`;

export const WorkArea = styled.div`
  height: 100vh ;
  width: 100%;
  background: ${globalTheme.colors.white};

  .absoluteBadge{
    position: absolute;
        right: 7%;
    top: 4%;
  }
`;

export const ButtonLoader = ({ margin = 0, size = "22px", color = '#101010', thickness = "2px", className }) => {
  const loaderStyle = {
    margin,
    width: size,
    height: size,
    border: `${thickness} solid ${color}`,
    borderBottomColor: 'transparent',
    borderRadius: '50%',
    display: 'inline-block',
    boxSizing: 'border-box',
    animation: 'rotation 1s linear infinite',
  }

  return <span style={loaderStyle} className={className}></span>;
};

export const ActionMenu = ({
  toggleIcon,
  className,
  btnName,
  menuList = [],
  staticLabel = false,
  selectedValue,
  fontColor,
  fontSize,
  onSelect,
}) => {

  const navigate = useNavigate();
  const wrapperRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  const [selected, setSelected] = useState({
    name: btnName,
    icon: menuList?.[0]?.icon
  });

  // Keep the displayed label/icon in sync with the controlled selected value
  useEffect(() => {
    if (selectedValue === undefined) return;
    const match = menuList.find((option) => option.value === selectedValue);
    if (match) {
      setSelected({ name: match.dropmenu, icon: match.icon });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };

  }, [isOpen]);


  // Is this option the one already in effect? Only true when the consumer
  // passes a controlled `selectedValue` AND the option carries a value, so
  // pure action/route menus (no value, no selectedValue) are never affected.
  const isCurrent = (option) =>
    selectedValue !== undefined &&
    option?.value !== undefined &&
    option.value === selectedValue;

  const handleItemClick = (e, option) => {
    e.stopPropagation();

    // Re-picking the value that is already active is a no-op. Falling through
    // would setSelected() a fresh object (a guaranteed re-render), re-dispatch
    // the same value, re-run every effect keyed on it and — for the module
    // switcher — navigate away, all to end up exactly where we started. Close
    // the menu and stop.
    if (isCurrent(option)) {
      setIsOpen(false);
      return;
    }

    if (!staticLabel) {
      setSelected({
        name: option.dropmenu,
        icon: option.icon
      });
    }

    if (option?.action) option.action();

    if (option?.route) navigate(`/${option.route}`);

    if (option?.value !== undefined && onSelect) onSelect(option.value, option);

    setIsOpen(false);
  };


  const toggleMenu = (e) => {
    e.stopPropagation();
    setIsOpen(prev => !prev);
  };


  return (
    <OptionsWrap
      ref={wrapperRef}
      className={`${className || ""} ${isOpen ? "active" : ""}`}
    >

      {/* BUTTON */}
      <Flexbox gap={8} spaceBW alignCenter onClick={toggleMenu}>
        <Flexbox gap={8} alignCenter>
          {selected?.icon}
          <Text
            inter
            medium
            style={{
              ...(fontColor ? { color: fontColor } : {}),
              ...(fontSize ? { fontSize: typeof fontSize === "number" ? `${fontSize}px` : fontSize } : {}),
            }}
            {...(!fontSize ? { font14: true } : {})}
            {...(!fontColor ? { nuetral13: true } : {})}
          >
            {selected?.name}
          </Text>
        </Flexbox>
        <Icon>{toggleIcon || <ArrowDown />}</Icon>
      </Flexbox>


      {/* MENU */}
      <MenuList>

        {menuList.map((option, index) => (

          <MenuItem
            key={index}
            // Marked as the current choice: highlighted via .active and given a
            // default cursor so it doesn't invite a click that does nothing.
            className={isCurrent(option) ? "active" : ""}
            aria-current={isCurrent(option) ? "true" : undefined}
            style={isCurrent(option) ? { cursor: "default" } : undefined}
            onClick={(e) => handleItemClick(e, option)}
          >
            {option.icon}
            <Flexbox column>
              {option.dropmenu}
              <Text font12 inter regular grey2> {option.subMenu}</Text>
            </Flexbox>
          </MenuItem>

        ))}

      </MenuList>

    </OptionsWrap>
  );
};

const OptionsWrap = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  display: block;
  position: relative;
  /* z-index: 800; */

  &.active{
    ul {
      visibility: visible;
      opacity: 1;
      /* transition: 0.4s ease-in; */
    }
  }
  /* ${props => props.$active && css`
    ul {
      visibility: visible;
      opacity: 1;
      transition: 0.4s ease-in;
    }
  `} */
`;

const MenuList = styled.ul.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: absolute;
  min-width: max-content;
  /* Right-align the menu to the trigger so triggers near the viewport's right
     edge (e.g. the module switcher) don't open off-screen. */
  right: 0;
  left: auto;
  top: 150%;
  background: ${globalTheme.colors.white1};
  border-radius: 16px;
  box-shadow: ${globalTheme.shadow};
  padding: 10px;
  /* Cap the height for long lists (e.g. towers) and scroll past that. */
  max-height: 320px;
  overflow-y: auto;
  visibility: hidden;
  opacity: 0;
  /* transition: 0.4s ease-in; */
  /* Above the sticky table head (z-index 99) and above row tooltips (150),
     otherwise an open row menu is painted underneath them. */
  z-index: 200;
`;

const MenuItem = styled.li.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  color: ${globalTheme?.colors?.nuetral13};
  font-family: ${globalTheme.fonts.inter};
  font-size: 14px;
  font-style: normal;
  font-weight:  ${globalTheme.fontWeights.normal};
  line-height: 20px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 6px 8px;
  /* transition: 0.4s ease-in; */
  ${props => props.disabled &&
    css`
      cursor: not-allowed;
      color:${globalTheme?.colors?.black4};
    `}

  svg {
    min-width: 14px;
    max-width: 14px;
    min-height: 14px;
    max-height: 14px;

    path {
      /* transition: 0.4s ease-in; */
    }
  }

  &:hover {
     color: ${globalTheme.colors.black4};
    svg path {
      fill: ${globalTheme.colors.primary10};
      /* transition: 0.4s ease-in; */
    }
  }

  &:not(:first-child) {
    margin-top: 2px;
  }

  &:hover,
  &.active,
  &:active {
  background: ${({ disabled }) => disabled ? "" : globalTheme.colors.nuetral2};
  color: ${({ disabled }) => disabled ? globalTheme?.colors?.nuetral5 : globalTheme?.colors?.primary10};
  /* transition: 0.4s ease-in; */
  }
`;

const Icon = styled.span.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  cursor: pointer;
   display: block;
  position: relative;
  line-height: 0;
`;

export const ProgressBar = ({ className, width, color, percentage, title, Texts, Total, dotColor, sideText, children, Badgepercentage, bgColor, onClick }) => (
  <ProgressBarWrapper className={className}>
    {(dotColor || title || Texts || Total || percentage || Badgepercentage || children) &&
      (<Flexbox alignCenter spaceBW noWrap gap={50} className={`mb10 ${onClick ? "pointer" : ""}`} onClick={onClick}>
        <Flexbox alignCenter gap={2}>
          {dotColor && <span className="Dotbadge" style={{ backgroundColor: dotColor }}></span>}
          <Text font13 grey2 inter>
            {(title || Texts)}
            <b>{Total}</b>
          </Text>
        </Flexbox>

        {percentage && <Text font12 grey2 inter>{width}%</Text>}
        {Badgepercentage && children}
      </Flexbox>)
    }

    <Flexbox spaceBW gap={12} alignCenter>
      <ProgressWrap bgColor={bgColor}>
        <ProgressBarFill width={width} color={color} />
      </ProgressWrap>
      {sideText &&
        <Text font13 inter regular black2>{width}</Text>
      }
    </Flexbox>
  </ProgressBarWrapper>
);


const ProgressBarWrapper = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: relative;
  width: 100%;

  .Dotbadge{
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background:${({ dotColor }) =>
    globalTheme.colors[dotColor] || dotColor || globalTheme.colors.green2} ;
  }
`;

const ProgressWrap = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: relative;
  height: 6px;
  width: 100%;
  border-radius: 10px;
   background: ${({ bgColor }) =>
    globalTheme.colors[bgColor] || bgColor || '#ededed'};
  overflow: hidden;
`;

const ProgressBarFill = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: ${({ width }) => (width ? `${width}%` : "0%")};
  background: ${({ color }) =>
    globalTheme.colors[color] || color || globalTheme.colors.green2};
  border-radius: 10px;
  transition: 0.4s ease;
`;

export const Div = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
      display: block;
      position: relative;
      width: ${({ width }) => width};
      max-height: ${props => props.maxHeight && `${props.maxHeight}`};
      height: ${props => props.Height && `${props.Height}`};
      padding: ${props => props.padding && `${props.padding}`};
      overflow: ${props => props.overflow ?? `auto`};
  border-radius: ${({ borderRadius }) => (borderRadius ? `${borderRadius}px` : "0px")};
      line-height: ${({ blankSpace }) => blankSpace ? '0' : 'normal'};
`;


export const Badge = ({
  className,
  green,
  yellow,
  red,
  borderRadius,
  blue,
  circle,
  secondary,
  white,
  greenLight,
  orange,
  icon,
  revIcon,
  black,
  noText,
  inter,
  primary,
  primaryGrey,
  DarkGrey,
  statusText,
  children,
  info,
  error,
  small,
  medium,
  dataTip,
  dataFor
}) => {
  return (
    <StyledBadge
      className={className}
      green={green}
      greenLight={greenLight}
      yellow={yellow}
      red={red}
      borderRadius={borderRadius}
      circle={circle}
      blue={blue}
      black={black}
      secondary={secondary}
      white={white}
      inter={inter}
      primary={primary}
      primaryGrey={primaryGrey}
      DarkGrey={DarkGrey}
      info={info}
      error={error}
      orange={orange}
      small={small}
      medium={medium}
      data-tip={dataTip}
      data- for={dataFor}
    >
      {icon && icon}
      {!noText && (statusText || children || "0")}
      {revIcon && revIcon}
    </StyledBadge>
  );
};

const StyledBadge = styled.span.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  gap:4px;
  display: flex;
  font-size: 12px;
  font-weight: 400;
  width: max-content;
  font-style: normal;
  align-items: center;
  background: transparent; 
    border-radius: ${(props) => props.borderRadius ? props.borderRadius : '5px'};

  justify-content: center;
  color: ${globalTheme.colors.black};
  font-family: ${globalTheme.fonts.poppins};
  line-height: ${({ small, medium }) => small ? '155%' : medium ? '177.5%' : '180%'};
  height: ${({ small, medium }) => small ? '20px' : medium ? '26px' : 'max-content'};
  padding: ${({ small, medium }) => small ? '2px 8px' : medium ? '3px 10px' : '4px 10px'};

  ${props => props.green && css`
      background: ${globalTheme.colors.green1};
      color: ${globalTheme.colors.green2};
    `}

  ${props => props.greenLight && css`
      background: ${globalTheme.colors.green6};
      color: ${globalTheme.colors.white1};
    `}
  ${props => props.yellow && css`
      background: ${globalTheme.colors.yellow2};
      color: ${globalTheme.colors.yellow};
    `}
  ${props => props.black && css`
      background: ${({ theme }) => theme.primary2};
      color: ${globalTheme.colors.grey10};
      /* border-radius: 20px; */
    `}
  ${props => props.circle && css`
          width: 26px;
          height: 26px;
      padding: 5px;
      border-radius: 50%;
    `}
  ${props => props.red && css`
      background: ${globalTheme.colors.primary1};
      color: ${globalTheme.colors.red};
    `}
  ${props => props.blue && css`
      background: ${globalTheme.colors.blue};
      color: ${globalTheme.colors.blue2};
    `}
  ${props => props.secondary && css`
      background: ${globalTheme.colors.nuetral2};
      color: ${globalTheme.colors.black4};
    `}
  ${props => props.white && css`
      background: ${globalTheme.colors.white1};
      color: ${globalTheme.colors.black3};
    `}
  ${props => props.orange && css`
    background: ${globalTheme.colors.primary1};
    color: ${globalTheme.colors.primary};
    `}
  ${props => props.primary && css`
    background: ${globalTheme.colors.primary};
    color: ${globalTheme.colors.white1};
    `}
  ${props => props.primaryGrey && css`
      background: ${globalTheme.colors.grey7};
      color: ${globalTheme.colors.nuetral13};
    `}
  ${props => props.DarkGrey && css`
      background: ${globalTheme.colors.nuetral6};
      color: ${globalTheme.colors.white1};
    `}
  ${props => props.info && css`
      background: ${globalTheme.colors.blue};
      color: ${globalTheme.colors.blue3};
      font: ${globalTheme.fonts.inter};
      font-weight: 500;
      font-size: 10px;
      line-height: 12px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      max-height: 20px;
      min-height: 20px;
      border-radius: 4px;
      padding: 4px 8px;
    `}
  
`;


export const FlipCardScene = styled.div`
  perspective: 1200px;
  width: 32%;
  min-height: 480px;
  max-height: 590px;
  position: relative;
  z-index: ${({ active }) => (active ? 30 : 1)};

  /* Matches the .respCard3 grid steps: 3-up -> 2-up -> 1-up. */
  @media (max-width: 1200px) {
    width: 48%;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-height: none;
  }
`;

export const BlurOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(173, 173, 173, 0.5);
    backdrop-filter: blur(2px);
    z-index: 20;
`;

export const FlipCardInner = styled.div`
  position: relative;
  width: 100%;
  min-height: 580px;
  transform-style: preserve-3d;
  transition: transform 0.8s ease;
  /* 'none' rather than 'rotateY(0deg)' for the idle state. The two are the
     same matrix, so the flip animates identically, but a non-none 3D
     transform promotes the card to its own GPU layer — and text on a
     composited layer is rasterized with grayscale instead of subpixel
     antialiasing, which reads as slightly soft/washed out. */
  transform: ${({ flipped }) => (flipped ? 'rotateY(180deg)' : 'none')};

  /* Room/tower names wrap to a second line once the card is full-width, so
     the faces (which are absolutely positioned) need a little more room. */
  @media (max-width: 768px) {
    min-height: 620px;
  }
`;

export const CardFace = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
`;

export const FrontFace = styled(CardFace)``;

export const BackFace = styled(CardFace)`
  transform: rotateY(180deg);
`;

export const SlotPanel = styled.div`
  background: #fff;
  border-radius: 50px;
  border: 1px solid #e7e7e7;
  padding: 14px 14px 20px;
  height: 100%;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 768px) {
    border-radius: 28px;
    padding: 12px 12px 16px;
  }
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 50%;
  background: #f2f2f2;
  cursor: pointer;
  font-size: 14px;
`;

export const Breaker = styled.span.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
      width: 100%;
      display: block;
      position: relative;
      border-top: 1px solid ${props => props.borderColor || 'rgba(0, 0, 0, 0.06)'};
      margin-top: ${props => props.marginTop}px;
      margin-bottom: ${props => props.marginBottom}px;
`;

export const BreakerVertical = styled.span.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
      display: block;
      position: relative;
      border-right: 1px solid ${(props) => props.borderColor || '#f0f0f0'};
      height: ${(props) => props.height}px;
      margin-left: ${(props) => props.marginLeft}px;
      margin-right: ${(props) => props.marginRight}px;
`;

export const LoginWrapper = styled.div`
position: relative;
background: url('/src/assets/svg/anandiBG.svg');

`

export const StyledLink = styled(Link).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  display: inline-block;
  position: relative;
  color: ${({ theme }) => theme.primary};
  font-family: "Raleway", sans-serif;
  ${({ width }) => `width: ${width}`};
  ${({ fontSize }) => `font-size: ${fontSize || "12px"}`};
  ${({ textAlign }) => `text-align: ${textAlign || "left"}`};
  font-style: normal;
  font-weight: ${globalTheme.fontWeights.normal};
  line-height: 120%;
  text-decoration: none;
  ${({ defaultCursor, noPointer }) => `cursor: ${(defaultCursor || noPointer) ? "default" : "pointer"}`};
  // ${({ defaultCursor }) => `cursor: ${defaultCursor ? "default" : "pointer"}`};

  ${({ underline }) => underline && `text-decoration: underline`};

  // Apply dynamic color if provided as a prop
  ${({ color }) => color && `color: ${color};`}
  transition: 0.4s ease;

  &:hover {
    text-decoration: ${({ noHoverUnderline }) => noHoverUnderline ? 'none' : 'underline'};
    transition: 0.4s ease;
  }
`;

export const InputField = forwardRef(({
  id,
  type,
  name,
  label,
  error = "",
  isImp,
  impMsg,
  maxWidth,
  noLabel,
  disabled,
  hasIcon,
  onClick,
  onChange,
  onBlur,
  onFocus,
  value,
  rows,
  isOtp,
  min,
  height,
  // Textarea only. Lets a caller round the box to match the pill-shaped text
  // inputs; defaults to the original 8px so existing textareas are unchanged.
  borderRadius,
  max,
  revIcon,
  student,
  minWidth,
  className,
  onKeyDown,
  darkTheme,
  autoFocus,
  placeholder,
  isOtpLoading,
  onGetOtpBtnClick,
  countryCodeValue = "",
  isGetOtpBtnDisabled,
  onCountryCodeChange = e => { },
  isDarkTheme,
}, ref) => {
  const otpBtnRef = useRef(null);

  const [showPass, setShowPass] = useState(false);

  // keyDown handler
  const keyDownFunction = e => {
    if (e.key != "Enter") return;
    if (isOtp) {
      otpBtnRef?.current?.click();
      return;
    }
    onKeyDown(e);
  }

  return (
    <FormGroupInput
      type={type}
      // className={`${className} ${type === "number" && 'phoneDrop'} ${isOtp && 'getOtpWrap'}`}
      className={`${className} ${(type === "phone" || type === "telephone") && 'phoneDrop'} ${isOtp && 'getOtpWrap'}`}
      style={{ ...(maxWidth && { maxWidth: maxWidth }), ...(minWidth && { minWidth: minWidth }) }}
    >
      {(!noLabel && !student) ? (<LabelInput htmlFor={id}>{label || "Label Text"}<span>{isImp && " *"}</span></LabelInput>) : ""}
      {(type === "phone" || type === "telephone") && (
        <Dropdown
          placeholder='Select'
          value={countryCodeValue}
          onChange={onCountryCodeChange}
          // options={RawCountriesList?.map(codeIte => ({
          //   ...codeIte,
          //   value: codeIte?.mobileCode,
          //   label: `+${codeIte?.mobileCode} (${codeIte?.countryIsoCode})`,
          // }))}
          defaultChecked={1}
          name={name}
          autoFocus={autoFocus}
          className='numberDrop'
          noLabel
        />
      )}
      {type === "textarea" ? (
        <StyledTextarea
          type="textarea"
          id={id}
          ref={ref}
          name={name}
          value={value}
          onBlur={onBlur}
          rows={rows || 4}
          height={height}
          borderRadius={borderRadius}
          required={isImp}
          onClick={onClick}
          onFocus={onFocus}
          disabled={disabled}
          onChange={onChange}
          autoFocus={autoFocus}
          placeholder={placeholder}
          maxLength={65535}
          onKeyDown={keyDownFunction}
          className={disabled && "disabled"}
        />
      ) : type === "password" ? (
        // The eye lives with the input, not at the bottom of the form group.
        <PasswordFieldWrap>
          <StyledInput
            id={id}
            ref={ref}
            name={name}
            value={value}
            onBlur={onBlur}
            required={isImp}
            onClick={onClick}
            min={min}
            max={max}
            onFocus={onFocus}
            disabled={disabled}
            onChange={onChange}
            darkTheme={darkTheme}
            autoFocus={autoFocus}
            placeholder={placeholder}
            onKeyDown={keyDownFunction}
            maxLength={65535}
            paddingleft={revIcon && '40px'}
            className={disabled && "disabled"}
            type={showPass ? "text" : "password"}
          />
          <PasswordToggle onClick={() => setShowPass(!showPass)}>
            {showPass ? <EyeOpen color={globalTheme.colors.nuetral6} /> : <EyeClose color={globalTheme.colors.nuetral6} />}
          </PasswordToggle>
        </PasswordFieldWrap>
      ) : (
        <StyledInput
          id={id}
          ref={ref}
          name={name}
          value={value}
          onBlur={onBlur}
          required={isImp}
          onClick={onClick}
          min={min}
          max={max}
          onFocus={onFocus}
          disabled={disabled}
          onChange={onChange}
          darkTheme={darkTheme}
          autoFocus={autoFocus}
          placeholder={placeholder}
          onKeyDown={keyDownFunction}
          maxLength={65535}
          paddingleft={revIcon && '40px'}
          className={disabled && "disabled"}
          type={type ? (showPass ? "text" : type) : "text"}
        />
      )}
      {student ? <LabelInput htmlFor={id}>{label ? label : "Label Text"}<span>{isImp ? "*" : ""}</span></LabelInput> : ""}
      {isOtp && <Button primaryFilled buttonXs name={isOtpLoading ? <ButtonLoader size="17px" /> : 'Get OTP'} className='floatingOTP' ref={otpBtnRef} disabled={isGetOtpBtnDisabled} onClick={onGetOtpBtnClick} />}
      {hasIcon && <div className={`floatingIcon`} style={revIcon && { left: '15px' }}>{hasIcon}</div>}
      {error && (<ErrorMessage>{error || "Something Went Wrong"}</ErrorMessage>)}
      {impMsg && (<Text font12 grey2 plex className='mt8'>{impMsg}</Text>)}
    </FormGroupInput>
  );
});

const StyledTextarea = styled.textarea.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  display: block;
  position: relative;
  height: ${props => (props.height ? props.height : '128px')};
  /* Rounded boxes need more side padding so the text clears the curve. */
  padding: ${props => (props.borderRadius ? '12px 20px' : '10px 16px')};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '8px')};
  border: 1px solid ${props => (props.darkTheme ? globalTheme.colors.black : globalTheme.colors.grey4)};
  font-family: ${globalTheme.colors.inter};
  background: ${props => (props.darkTheme ? globalTheme.colors.black : globalTheme.colors.white1)};
  width: 100%;
  font-size: 14px;
  line-height: 150%;
  resize: none;
  color: ${globalTheme.colors.nuetral6} !important;

  /* &::placeholder {
    color: ${globalTheme.colors.nuetral8};
    font-size: 12px;
    font-style: normal;
    font-weight: ${globalTheme.fontWeights.normal};
    line-height: 150%;
  } */
    

  &::placeholder {
    color: ${globalTheme.colors.grey3};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:focus,
  &:focus-visible,
  &:focus-within {
    outline: none;
    box-shadow: none;
  }
`;

export const FormGroupInput = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  display: block;
  position: relative;
  width: 100%;
  /* overflow: hidden; */
  max-width: 100%;

  ${({ type }) => type === "date" && `
    input {
      color: ${globalTheme.colors.nuetral6};

      svg path{
         stroke:#fff;
         fill:#fff;
      }
    }
    
    &:hover input {
      border-color: ${globalTheme.colors.blue4};
      background: ${globalTheme.colors.white};
      transition: border-color 0.2s, background 0.2s;
      cursor: pointer;
    }
  `};

  &.phoneDrop{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    overflow: visible;

     input {
     min-width: 35px !important;
     font-size: 14px !important;
     color: ${globalTheme.colors.grey2} !important;
      border-radius: 0;
      border-left: 0;
    }

     .css-13cymwt-control{
      border-radius: 6px 0px 0px 6px;
    }
    .css-t3ipsp-control{
      border-radius: 6px 0px 0px 6px;
    }

    .label{
      width: 100%;
    }

    .numberDrop{
      max-width: 120px;
      /* background: ${globalTheme.colors.nuetral1}; */
      transition: 0.4s ease;

      .css-t3ipsp-control, .css-13cymwt-control{
        padding: 2px 6px;
        background: #EAEAEA ;
      }

      .css-1jqq78o-placeholder{
        display: flex;
        align-items:center;
        justify-content: center;
      }
      
      .react-dropdown-select-content{
        justify-content: center;
      }

      .react-dropdown-select-dropdown-handle{
        position: relative;
        left: -12px;
        top: -1px;
      }

      .react-dropdown-select{
        padding: 0 !important;
        border-radius: 10px 0 0 10px !important;
        background: ${globalTheme.colors.grey5};
        min-height: 44px;

        .react-dropdown-select-input{
          color: ${globalTheme.colors.nuetral13};

          &::placeholder{
            color: ${globalTheme.colors.nuetral13};
          }
        }
      }
    }

    input{
      max-width: calc(100% - 120px);
      width: 100%;
      border-radius: 0 10px 10px 0;
      transition: 0.4s ease;
    }

    &.getOtpWrap{

      .floatingOTP{
        min-height: 44px;
        min-width: 84px;
        max-width: 84px;
        overflow: hidden;
        border-radius: 0 10px 10px 0;
      }

      input{
        max-width: calc(100% - 159px);
        border-radius: 0 0;
        transition: 0.4s ease;
      }
    }

    @keyframes fullFledge {
      0%{
        width: 0;
      }
      100%{
        width: 100%
      }
    }
  }

  .floatingIcon {
    position: absolute;
    right: 15px;
    top: 12px;
    width:max-content;
  }

  .optsCont {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-left: 5px;
    gap: 15px;
  }
`;

export const LabelInput = styled.label.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  color: ${globalTheme.colors.black4};
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 17.5px;
  font-family: 'inter';
  display: block;
  width: 100%;
  margin-bottom: ${({ marginBottom }) => marginBottom || "5px"};
  margin-top: ${({ marginTop }) => marginTop || "0px"};
 
   span {
    color: ${globalTheme.colors.red};
    outline: none !important;
  }
`;

const StyledInput = styled.input.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  display: block;
  position: relative;
  padding: 10px 16px;
  padding-left: ${({ paddingleft }) => paddingleft || '16px'};
  border-radius: 50px;
  border: 1px solid ${(props) => (props.darkTheme ? globalTheme.colors.black : globalTheme.colors.nuetral2)};
  font-family: ${globalTheme.colors.inter};
  background: ${(props) => (props.darkTheme ? globalTheme.colors.black : globalTheme.colors.nuetral2)};
  width: 100%;
  font-size: 14px;
  line-height: 150%;
  height: 44px;
  color: ${globalTheme.colors.grey2};

  &::placeholder {
    color: ${globalTheme.colors.grey3};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }

  &:focus,
  &:focus-visible,
  &:focus-within {
    outline: none;
    box-shadow: none;
  }
  
  ${({ type }) => type === "date" && `
    cursor: text;
    &::-webkit-calendar-picker-indicator {
      cursor: pointer;
      fill:  ${globalTheme.colors.grey2};
    }
    
    &:hover {
      border-color: ${globalTheme.colors.blue4};
      background: ${globalTheme.colors.white};
      transition: border-color 0.2s, background 0.2s;
    }
  `};
`;

export const ErrorMessage = styled.span.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  color: ${globalTheme.colors.red};
  font-family: 'inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  position: absolute;
  bottom: -20px;
  min-width: max-content;
`;

// Wraps ONLY the input of a password field, so the show/hide eye can anchor to
// the input's own box. Password fields are never phone/OTP fields, so this
// extra element can't disturb the flex row those variants rely on.
const PasswordFieldWrap = styled.div`
  position: relative;
  display: block;
  width: 100%;
`;

const PasswordToggle = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: absolute;
  right: 12px;
  line-height: 0;
  /* Centred on the input — it used to be bottom:10px against the whole form
     group, so any helper text or in-flow content under the field (e.g. the
     password rules on the reset screen) pushed the eye down out of the input
     and on top of that text. Anchoring inside PasswordFieldWrap keeps it in
     the field whatever is rendered below, and at any input height. */
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

export const NoBorderInput = styled(InputField).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  input{
  background:transparent;
    border: none;
    height:auto;
    border-radius: 0;
    padding: 0;
  }  
`;

export const Dropdown = forwardRef(({
  id,
  name,
  label,
  value,
  isbold,
  onBlur,
  impMsg,
  noLabel,
  maxWidth,
  minWidth,
  onInputChange = () => { },
  className,
  darkTheme,
  error = "",
  defaultValue,
  isImp = false,
  multi = false,
  placeholder = "",
  onChange = e => { },
  menuPlacement,
  onClick = e => { },
  disabled = false,
  autoFocus = false,
  isLoading = false,
  isdeleteIcon = false,
  onDeleteOption = () => { },
  options = [
    { value: 'First', label: 'First' },
    { value: 'Second', label: 'Second' },
    { value: 'Third', label: 'Third' },
  ],
  CustomOption
}, ref) => {
  const [isOpenMenu, setMenuIsOpen] = useState(false);

  const handleMenuOpen = () => setMenuIsOpen(true);
  const handleMenuClose = () => setMenuIsOpen(false);

  const isGrouped = Array.isArray(options) && options.some(opt => Array.isArray(opt?.options));
  const flatOptions = isGrouped ? options.flatMap(group => Array.isArray(group?.options) ? group.options : []) : options;
  const selectedOption = ![undefined, ""].includes(value) ? flatOptions?.find(item => item?.value === value) : null;

  // const CustomOption = ({ innerProps, data, isFocused, isSelected }) => (
  //   <div
  //     {...innerProps}
  //     style={{
  //       display: 'flex',
  //       alignItems: 'center',
  //       justifyContent: 'space-between',
  //       padding: '8px 12px',
  //       backgroundColor: isFocused ? globalTheme.colors.grey4 : 'transparent',
  //       color: globalTheme.colors.black4,
  //       cursor: 'pointer',
  //       borderRadius: '8px',
  //       fontSize: '14px',
  //       fontWeight: '400',
  //       lineHeight: '120%',
  //       transition: '0.3s'
  //     }}
  //   >
  //     <span>{data.label}</span>
  //     {isdeleteIcon && (
  //       <div
  //         onClick={e => {
  //           e.stopPropagation();
  //           onDeleteOption(data);
  //         }}
  //         style={{
  //           padding: '4px',
  //           borderRadius: '4px',
  //           display: 'flex',
  //           alignItems: 'center',
  //           justifyContent: 'center',
  //           cursor: 'pointer',
  //           transition: 'background-color 0.2s'
  //         }}


  //       >
  //         {/* {!data.hideTrash && <TrashIcon />} */}
  //       </div>
  //     )}
  //   </div>
  // );

  return (
    <DropFormGroup onClick={onClick} className={`${className}`} minWidth={GetValueWithUnit(minWidth)} maxWidth={GetValueWithUnit(maxWidth)} disabled={disabled}>
      {!noLabel && <DropLabel darkTheme={darkTheme} htmlFor={id}>{isbold && <b>{isbold}</b>}{label || "Label Text"}<span>{isImp && " *"}</span></DropLabel>}
      {isLoading ? (
        <Flexbox justiCenter maxWidth="100%">
          <ButtonLoader color={globalTheme?.colors?.black3} margin="auto" size="16px" />
        </Flexbox>
      ) : (
        <StyledDropdown
          ref={ref}
          multi={multi}
          onBlur={onBlur}
          onInputChange={onInputChange}
          required={isImp}
          options={options}
          autoFocus={autoFocus}
          isDisabled={disabled}
          value={selectedOption}
          defaultValue={defaultValue}
          onMenuOpen={handleMenuOpen}
          onMenuClose={handleMenuClose}
          placeholder={placeholder || "Select"}
          onChange={e => onChange(({ ...e, name }))}
          className={`${isOpenMenu && 'isMenuRotate'}`}
          components={isdeleteIcon ? { Option: CustomOption } : {}}
          menuPlacement={menuPlacement ? menuPlacement : "auto"}
        />
      )}
      {error && (<ErrorMessage>{error || "Something Went Wrong"}</ErrorMessage>)}
      {impMsg && (<Text font12 grey2 inter className='mt8'>{impMsg}</Text>)}
    </DropFormGroup>
  );
});

const DropFormGroup = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  display: block;
  position: relative;
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || "none"};
  min-width: ${({ minWidth }) => minWidth || "none"};

  .react-dropdown-select-dropdown {
    border-radius: 6px;
    background: ${globalTheme.colors.white1};
    border: none;
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.16);
  }
  
`;

const StyledDropdown = styled(Select).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`

.css-1u9des2-indicatorSeparator{
  display: none;
}

&.isMenuRotate .css-tj5bde-Svg{
  transform: rotate(180deg);
} 

.css-19bb58m{
  width: max-content;
}

.css-art2ul-ValueContainer2{
  padding: 2px 0;
}

 .css-t3ipsp-control,.css-13cymwt-control {
  min-height: 44px;
  padding: 2px 12px;
  background: ${globalTheme.colors.white1} !important;
}

 .css-13cymwt-control {
  border-color: ${globalTheme.colors.grey4} ;
  border-radius: 8px;
}

 .css-13cymwt-control:hover {
  border-color: ${globalTheme.colors.grey4};
}

 .css-1xc3v61-indicatorContainer:hover {
  color: ${globalTheme.colors.black4};
}

.css-1xc3v61-indicatorContainer{
  padding: 0;
}

 .css-tj5bde-Svg {
  fill: ${globalTheme.colors.grey3};
  opacity: 0.6;
  transition: 0.3s;
}

 .css-15lsz6c-indicatorContainer svg path {
  fill: ${globalTheme.colors.grey3}
}

 .css-1u9des2-indicatorSeparator {
  display: none;
}

 .css-1nmdiq5-menu {
  margin: 0;
  z-index: 1;
  border-radius: 6px;
  background: ${globalTheme.colors.white1};
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.16);
  margin-left: 2px;
}

 .css-d7l1ni-option {
  background-color: ${globalTheme.colors.nuetral2};
  color: ${globalTheme.colors.black4};
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  z-index: 10;
}

 .css-d7l1ni-option:active {
  background-color: ${globalTheme.colors.grey4};
}

 .css-10wo9uf-option {
  color: ${globalTheme.colors.black4};
  transition: 0.3s;
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  padding: 8px 12px;
  /* z-index: 99; */
}

 .css-tr4s17-option {
  background: ${globalTheme.colors.grey4};
  color:  ${globalTheme.colors.black4};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
}

.css-1nmdiq5-menu .css-tr4s17-option:active {
  background: ${globalTheme.colors.grey4} !important;
}

 .css-1jj59y3-MenuList2 {
  padding: 10px;
}

 .css-w9q2zk-Input2 {
  margin: 0;
  padding-bottom: 0;
  padding-top: 0;
}

 .css-1jqq78o-placeholder {
  color: ${globalTheme.colors.grey3};
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}

 [class*="singleValue"] {
  color: ${globalTheme.colors.black4};
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}

 .css-t3ipsp-control {
  box-shadow: none;
  border-color: ${globalTheme.colors.grey4};
  background-color: ${globalTheme.colors.white1};
  border-radius: 6px;
  cursor: pointer !important;
}

 .css-t3ipsp-control:hover {
  border-color: ${globalTheme.colors.grey4};
  box-shadow: none;
}

/* .css-t3ipsp-control .css-15lsz6c-indicatorContainer svg{
  transform: rotate(180deg);
  transition: .3s;
} */

.css-15lsz6c-indicatorContainer{
  padding: 0;
}

`;

const DropLabel = styled.label.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  color: ${globalTheme.colors.black4};
  font-size: 14px;
  font-style: normal;
  font-weight: ${globalTheme.fontWeights.normal};
  line-height: 17.5px;
  font-family: 'inter';
  margin-bottom: 5px;
  display: block;
  width: 100%;

  span {
    color: ${globalTheme.colors.error};
  }
`;


const StyledMultiDrop = styled(Multiselect).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: relative;

  .icon_down_dir{
    right: 6px;
    top: 50%;
    transform: translateY(-35%);
    width: 20px;

    &::before{
      display: none;
    }

    svg{
      width: 20px;
      height: 20px;
    }
  }

  .searchWrapper{
    background: ${globalTheme.colors.white1};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    padding: 4px 12px;
    border-radius: 80px;
    border: 1px solid ${globalTheme.colors.grey4};
    width: 100%;
    font-family: ${globalTheme.fonts.inter};
    font-size: 14px;
    line-height: 130%;
    height: 36px;
    overflow: auto;
    color: ${globalTheme.colors.black3};
    gap: 4px;
    cursor: pointer;
    transition: 0.4s;



    &:hover{
      border-color: ${globalTheme.colors.nuetral13};
    }

    input{
      margin: 0;
      font-family: ${globalTheme.fonts.inter};
      font-size: 14px;
      color: ${globalTheme.colors.black3};

      &::placeholder{
        color: ${globalTheme.colors.grey2};
      }
    }

    .chip{
      display: inline-flex !important;
      align-items: center !important;
      visibility: visible !important;
      opacity: 1 !important;
      margin: 0 !important;
      background: ${globalTheme.colors.nuetral2} !important;
      font-family: ${globalTheme.fonts.inter} !important;
      color: ${globalTheme.colors.black3} !important;
      font-size: 12px !important;
      font-weight: 500 !important;
      padding: 2px 8px !important;
      border-radius: 50px !important;
      -webkit-font-smoothing: antialiased !important;

      img{
        display: none !important;
      }
    }
  }

  .optionListContainer{
    border-radius: 6px;
    background: ${globalTheme.colors.white1};
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.16);
    margin-top: 10px;
    
    ul{
      padding: 12px 16px;
      border-color: ${globalTheme.colors.white1};
      
      .option{
        background: transparent;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row-reverse;
        padding: 10px 0;
        font-size: 12px;
        color: ${globalTheme.colors.nuetral13};
        font-weight: normal;
        font-family: ${globalTheme.fonts.inter};
        max-width: 100%;
        overflow: hidden;
  
        input{
          margin: 0;
          transform: translateX(35px);

          &:checked{
            &::after{
              outline: 1px solid ${globalTheme.colors.primary};
            }
            &::before{
              visibility: visible;
              opacity: 1;
              transition: 0.4s ease;
            }
          }

          &::after{
            content: '';
            background-color: transparent;
            outline: 1px solid ${globalTheme.colors.nuetral6};
            transition: 0.2s;
            border-radius: 2px;
            overflow: hidden;
            position: absolute;
            left: -37px;
            display: block;
            height: 14px;
            width: 14px;
          }

          &::before{
            content: '';
            position: absolute;
            left: -32px;
            top: 2px;
            width: 4px;
            height: 9px;
            border: solid ${globalTheme.colors.primary};
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
            visibility: hidden;
            opacity: 0;
            transition: 0.4s ease;
          }
        }
      }
  
      .highlightOption{
        background: transparent !important;
        color: ${globalTheme.colors.nuetral13} !important;
      }

      .highlightOption:hover{
        background: ${globalTheme.colors.nuetral1} !important;
      }

      .highlight{
        background: transparent !important;
        color: ${globalTheme.colors.nuetral13} !important;
      }
    }
  }
`;

export const MultiDropdown = ({
  id,
  label,
  isImp,
  noLabel,
  maxWidth,
  onChange, // Callback when selection changes
  selectedValues = [], // Default selected values
  className,
  error = "",
  placeholder,
  multi = false,
  defaultValue,
  onClick,
  options = [
    { cat: 'Admin', key: 'Admin' },
    { cat: 'Team Lead', key: 'Team Lead' },
    { cat: 'Counsellor', key: 'Counsellor' },
    { cat: 'User', key: 'User' },
    { cat: 'Super Admin', key: 'Super Admin' },
    { cat: 'Manager', key: 'Manager' }
  ]
}) => {

  // Long labels (e.g. full equipment names) overflow the fixed-width menu —
  // truncate with an ellipsis and surface the full text via the native title
  // tooltip. The menu option flexes to the row's free space; the selected chip
  // gets a hard cap so the control stays tidy. The explicit lineHeight matters:
  // ancestors (WrapperBox/popups) set line-height: 0, and overflow:hidden on a
  // zero-height line box clips the text away entirely.
  const optionEllipsis = (value) => (
    <span
      title={value}
      style={{
        display: 'block',
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: 1.4,
      }}
    >
      {value}
    </span>
  );
  const chipEllipsis = (value) => (
    <span
      title={value}
      style={{
        display: 'block',
        maxWidth: 160,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: 1.4,
      }}
    >
      {value}
    </span>
  );

  // Instance ref so the custom arrow can call the lib's own toggle — out of the
  // box the arrow only opens the list (closing needs an outside click).
  const multiRef = useRef(null);

  return (
    <DropFormGroup onClick={onClick} className={`${className}`} maxWidth={GetValueWithUnit(maxWidth)}>
      {!noLabel && (
        <DropLabel htmlFor={id}>
          {label || "Label Text"}
          <span>{isImp ? " *" : ""}</span>
        </DropLabel>
      )}
      <StyledMultiDrop
        ref={multiRef}
        displayValue="key"
        options={options}
        selectedValues={selectedValues}
        onSelect={(selectedList, selectedItem) => {
          if (onChange) onChange(selectedList, selectedItem);
        }}
        onRemove={(removedList, removedItem) => {
          if (onChange) onChange(removedList, removedItem);
        }}
        placeholder={selectedValues?.length > 0 ? '' : placeholder}
        showCheckbox
        avoidHighlightFirstOption
        showArrow
        optionValueDecorator={optionEllipsis}
        selectedValueDecorator={chipEllipsis}

        customArrow={
          selectedValues?.length > 0 ? (
            <CloseCircle
              onClick={(e) => {
                e.stopPropagation();
                if (onChange) onChange([], null);
              }}
              style={{ cursor: 'pointer', width: '20px', height: '20px' }}
            />
          ) : (
            <span
              onClick={(e) => {
                // Clicking the arrow toggles the menu both ways — the lib itself
                // only opens on input focus and closes via a 250ms blur timer.
                // That timer is the trap: closing with the arrow blurs the input,
                // and if the reopen click lands inside the 250ms window the
                // pending close fires right after our open and shuts it again.
                // So: kill any pending blur-close, then set the state we want
                // deterministically instead of blind-toggling.
                e.stopPropagation();
                const ms = multiRef.current;
                if (!ms) return;
                clearTimeout(ms.optionTimeout);
                if (ms.state?.toggleOptionsList) {
                  ms.onCloseOptionList();
                } else {
                  ms.toggelOptionList();
                }
              }}
              style={{ display: 'inline-flex', cursor: 'pointer' }}
            >
              <ArrowDown />
            </span>
          )
        }
      />
      {error && (<ErrorMessage>{error || "Something Went Wrong"}</ErrorMessage>)}
    </DropFormGroup>
  );
};

export const CalendarDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 100;
  background: ${globalTheme.colors.white1};
  border: 1px solid ${globalTheme.colors.nuetral2};
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1);
  min-width: 300px;
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  text-align: center;
`;

export const DayCell = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: ${props => props.empty ? 'default' : 'pointer'};
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: ${props => props.isSelected ? '600' : props.isToday ? '600' : '400'};
  color: ${props =>
    props.empty ? 'transparent' :
      props.isSelected ? globalTheme.colors.white1 :
        props.isToday ? globalTheme.colors.black3 :
          props.otherMonth ? globalTheme.colors.grey3 :
            globalTheme.colors.black3};
  background: ${props => props.isSelected ? globalTheme.colors.black3 : 'transparent'};

  &:hover {
    background: ${props => props.empty ? 'transparent' : props.isSelected ? globalTheme.colors.black3 : globalTheme.colors.nuetral2};
  }
`;

export const NavButton = styled(Flexbox)`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  &:hover {
    background: ${globalTheme.colors.nuetral2};
  }
`;

export const ToggleButton = ({ onChange, checked, disabled, name, round, height, width, toggleSize, className }) => (
  <Switch height={height} width={width} disabled={disabled} className={className}>
    <HiddenCheckbox type="checkbox" name={name} checked={checked} disabled={disabled} onChange={onChange} />
    <Slider toggleSize={toggleSize} round={round ? 1 : 0} />
  </Switch>
);


const Switch = styled.label.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: relative;
  display: inline-block;
  min-width: 26px;
  height: ${props => (props.height ? `${props.height}px` : "14px")};
  width: ${props => (props.width ? `${props.width}px` : "26px")};
  cursor: ${props => (props.disabled ? `not-allowed` : "pointer")};
`;

const Slider = styled.span.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${globalTheme.colors.nuetral3};
  transition: 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: "";
    /* height: 8px;
    width: 8px; */
    height: ${(props) => (props.toggleSize ? `${props.toggleSize}px` : "8px")};
    width: ${(props) => (props.toggleSize ? `${props.toggleSize}px` : "8px")};
    left: 3px;
    bottom: 2px;
    filter: drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.06)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.10));
    background-color: ${globalTheme.colors.white1};
    transition: 0.4s;
    border-radius: 50%;
  }
`;

const HiddenCheckbox = styled.input.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${Slider} {
    background-color: ${globalTheme.colors.black3};
  }

  &:focus + ${Slider} {
    box-shadow: 0 0 1px ${globalTheme.colors.black3};
  }

  &:checked + ${Slider}:before {
    transform: translateX(12px);
  }

  &:disabled + ${Slider} {
    cursor: not-allowed;
  }
`;


export const FloatingDownload = ({
  label,
  isImp,
  hasFile,
  btnText,
  onClick = () => console.warn("Pass 'onClick'"),
  error = "",
  disabled,
  className,
  placeholder,
  viewOnly = false,
  asFileUploader = false,
  name = "provide name",
  showViewIcon = {
    show: false,
    disabled: false,
    onViewClick: () => console.warn("Pass 'onViewClick'")
  },
  showClearIcon = {
    show: false,
    disabled: false,
    onClearClick: () => console.warn("Pass 'onClearClick'")
  },
  showDownloadIcon = {
    show: false,
    disabled: false,
    onDownloadClick: () => console.warn("Pass 'onDownloadClick'")
  },
}) => {
  return (
    <UploadFormGroup onClick={e => {
      e.stopPropagation();
      !disabled && onClick(e)
    }} className={className} disabled={disabled} >
      <LabelInput>{label || "Label Text"}<span>{isImp ? " *" : ""}</span></LabelInput>
      {!asFileUploader && (<input type="file" name={name} id="uploadBox" disabled={disabled} />)}
      <label htmlFor={!asFileUploader ? "uploadBox" : ""}>
        <BrowseText>{placeholder || "Choose Your File"}</BrowseText>
        {(!showClearIcon?.show && !viewOnly) && (
          <BrowseButton disabled={disabled}>{btnText || "Browse"}</BrowseButton>
        )}
        {(showViewIcon?.show || showClearIcon?.show) && (
          <Flexbox onClick={e => e.stopPropagation()} className='upload_cont_div' maxWidth='max-content' padding='0 10px' gap={8} alignCenter>
            {showViewIcon?.show && (
              <EyeOpen
                className={showViewIcon?.disabled ? 'disabled' : ''}
                color={globalTheme.colors.grey3}
                onClick={e => {
                  e.stopPropagation();
                  if (!showViewIcon?.disabled) {
                    showViewIcon?.onViewClick?.();
                  }
                }}
              />
            )}
            {showDownloadIcon?.show && (
              <>
                <Text color={globalTheme.colors.grey3}>|</Text>
                <UploadFile
                  onClick={e => {
                    e.stopPropagation();
                    if (!showDownloadIcon?.disabled) {
                      showDownloadIcon?.onDownloadClick?.();
                    }
                  }}
                />
              </>
            )}
            {(showViewIcon?.show && showClearIcon?.show) && (
              <Text color={globalTheme.colors.grey3}>|</Text>
            )}
            {showClearIcon?.show && (
              <CloseCircle
                className={showClearIcon?.disabled ? 'disabled' : ''}
                color={globalTheme.colors.grey3}
                onClick={e => {
                  e.stopPropagation();
                  if (!showClearIcon?.disabled) {
                    showClearIcon?.onClearClick?.();
                  }
                }}
              />
            )}
          </Flexbox>
        )}
        {hasFile && <FloatDownload />}
      </label>
      {error && (<ErrorMessage>{error || "Something Went Wrong"}</ErrorMessage>)}
    </UploadFormGroup >
  );
};

const UploadFormGroup = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
      position: relative;
      display: block;
      width: 100%;

      input {
        display: none;
      }

      label:nth-of-type(2) {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 6px 6px;
        overflow: hidden;
        border: 1px solid ${globalTheme?.colors?.grey4};
        height: 43px !important;
        background: ${globalTheme?.colors?.white1};
        cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
     }

      label:nth-of-type(2) > span:nth-of-type(1) {
        flex-grow: 1;
        margin-right: 15px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
     }

.upload_cont_div{
  >svg:hover{
  cursor: pointer;
    >path{
       fill: ${globalTheme?.colors?.nuetral13};
    }
  }
  >p{
    cursor: default;
  }
}
`;

const BrowseText = styled.span.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  color: ${globalTheme.colors.grey3};
  font-family: 'League Spartan';
  font-size: 14px;
  font-style: normal;
  font-weight: ${globalTheme.fontWeights.normal};
  line-height: 150%;
  padding-left: 16px;
`;

const BrowseButton = styled.span.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  background: ${globalTheme.colors.grey5};
  color: ${globalTheme.colors.nuetral13};
  font-family: 'League Spartan';
  font-size: 14px;
  font-style: normal;
  font-weight: ${globalTheme.fontWeights.normal};
  line-height: 150%;
  padding: 9.5px 12px;
  cursor: pointer;
  ${props => props.disabled && css`
    background: ${globalTheme.colors.grey4};
    color: ${globalTheme.colors.nuetral13};
    cursor: not-allowed;
  `}
  white-space: nowrap;
  height: 100%;
`;

const FloatDownload = styled(UploadFile).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: absolute;
  right: 15px;
  top: 13px;
`;

export const FileUploadBox = ({ onFileSelect, maxFiles, currentCount = 0, onLimitExceeded }) => {
  const inputRef = useRef();
  const [isDragging, setIsDragging] = useState(false);

  const remaining = typeof maxFiles === "number" ? Math.max(maxFiles - currentCount, 0) : Infinity;
  const isFull = remaining <= 0;

  const acceptFiles = (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    if (isFull) {
      if (onLimitExceeded) onLimitExceeded(files.length, maxFiles);
      return;
    }
    if (files.length > remaining) {
      onFileSelect(files.slice(0, remaining));
      if (onLimitExceeded) onLimitExceeded(files.length, maxFiles);
      return;
    }
    onFileSelect(files);
  };

  const handleDragOver = e => {
    e.preventDefault();
    if (!isFull) setIsDragging(true);
  };

  const handleDragLeave = () => setIsDragging(false);

  const handleDrop = e => {
    e.preventDefault();
    setIsDragging(false);
    acceptFiles(e.dataTransfer.files);
  };

  const handleFileChange = e => {
    acceptFiles(e.target.files);
    e.target.value = "";
  };

  const handleClick = () => {
    if (isFull) {
      if (onLimitExceeded) onLimitExceeded(0, maxFiles);
      return;
    }
    inputRef.current.click();
  };

  return (
    <UploadContainer
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
      dragging={isDragging}
    >
      <HiddenInput
        type="file"
        ref={inputRef}
        onChange={handleFileChange}
        multiple
      />

      <UploadFile />
      <Text font14 inter black3 className='mt12'>Drag your file(s) to start uploading</Text>

      <Divider><span>or click to browse — PNG, JPG up to 10MB each</span></Divider>

      <Flexbox justiCenter alignCenter>
        <Button name='Browse Files' buttonMd primaryOutlined />
      </Flexbox>
    </UploadContainer >
  );
};

export const UploadContainer = styled.div`
  border: 2px dashed #ddd;
  border-radius: 10px;
  padding: 36px 24px;
  text-align: center;
  background-color: #fff;
  cursor: pointer;
  margin: 0 auto;
  transition: border-color 0.3s ease;

  ${({ dragging }) =>
    dragging &&
    `
    border-color: #ff5722;
    background-color: #fff8f4;
  `}
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  margin: 16px auto;
  width:50%;

  font-size: 14px;
  /* StyledWrapper sets line-height: 0, which this bare <span> inherits. On a
     wide screen the label is one line so it goes unnoticed, but as soon as it
     wraps every line renders at the same y-position — the text turns into an
     unreadable overlap. Set an explicit line-height so wrapping is safe. */
  line-height: 1.4;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #e0e0e0;
    margin: 0 10px;
  }

  /* A flex item will not shrink below its content width by default, so at 50%
     of a phone-width container the label overflowed past both rules instead of
     wrapping inside them. */
  > span {
    min-width: 0;
  }

  @media (max-width: 768px) {
    width: 100%;
    font-size: 12px;

    /* No room for decorative rules either side of a wrapped label. */
    &::before,
    &::after {
      display: none;
    }
  }
`;


export const SearchBar = ({ placeholder, searchFunction, clearSearch, maxWidth, onChange }) => {
  const [searchValue, setSearchValue] = useState("");

  return (
    <Flexbox alignCenter gap={8}>
      <Search />
      <NoBorderInput
        noLabel
        placeholder={placeholder}
        value={searchValue}
        maxWidth={maxWidth}
        onChange={(e) => {
          setSearchValue(e.target.value);
          // Optional live callback — lets callers debounce search-as-you-type.
          // Falls back to Enter-only behaviour when not provided.
          if (onChange) onChange(e.target.value);
        }}
        onKeyDown={(e) => {
          // if(e.key === 'Enter' && searchValue) {
          if (e.key === "Enter") {
            searchFunction(searchValue);
          }
        }}
      />
      {searchValue.length > 0 && (
        <Close
          onClick={() => {
            setSearchValue("");
            clearSearch();
          }}
          className={'pointer'}
        />

      )}


    </Flexbox>
  );
};


export const RoomCol = styled(Flexbox)`
    border-right: ${({ header }) => (header ? "none" : "1px solid #eee")};
  border-bottom: ${({ header }) => (header ? "none" : "1px solid #eee")};
  box-sizing: border-box;
  background: ${globalTheme.colors.white1};
`;

export const TimeCell = styled(Flexbox)`
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  background: ${({ header }) => (header ? globalTheme.colors.nuetral2 : "white")};
`;

export const BookingBlock = styled(Flexbox)`
  position: absolute;
  top: 10px;
  height: 44px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: ${({ color }) => {
    switch (color) {
      case "green":
        return "#C8F0D2";
      case "yellow":
        return "#FBE9B0";
      case "red":
        return "#F8D7D7";
      case "blue":
        return "#DDEAF0";
      case "purple":
        return "#E0D7F0";
      default:
        return "#E5E5E5";
    }
  }};
`;

export const BookingUser = styled.div`
  font-size: 10px;
  opacity: 0.8;
`;